// extracted by mini-css-extract-plugin
module.exports = {"link":"styles_link__3fJgL","primary":"styles_primary__167a3","light":"styles_light__1f8OE"};